module.exports = __webpack_public_path__ + "static/media/cherry_jam.e0e6b9e7.png";